var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"\n    tw-uppercase\n    tw-tracking-widest\n    tw-py-2\n    tw-px-6\n    tw-rounded-md\n    tw-cursor-pointer\n    tw-select-none\n    tw-inline-block\n    tw-font-medium\n  ",class:{
    'tw-text-xs': _vm.small,
    'tw-text-white': !_vm.inverted,
    'tw-bg-[#4164E3]': !_vm.inverted,
    'tw-text-[#4164E3]': _vm.inverted,
    'tw-bg-white': _vm.inverted,
    'tw-border-[#4164E3]': _vm.inverted,
    border: _vm.inverted,
    'tw-opacity-30': _vm.disabled,
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }